import {view} from '@sail/ui';
import {FormattedMessage} from 'react-intl';
import {ScreenWrapper} from 'src/components/core/ScreenWrapper';
import {UserFacingError} from 'src/utils/error';
import messages from 'src/utils/messages';
import {Text} from 'src/v2/components/common/Text';
import {useLogger} from 'src/utils/logger';

const AppError = ({error}: {error: Error}) => {
  const logger = useLogger();
  logger.log('crypto_payin_session.error', {
    error_type: 'APP_ERROR',
    error_message: error.message,
  });
  return (
    <ScreenWrapper alwaysCentered>
      <view.div
        css={{
          stack: 'y',
          gap: 'xsmall',
          alignX: 'center',
          textAlign: 'center',
          padding: '0px 24px',
        }}
      >
        <Text type="title">
          <FormattedMessage {...messages.somethingWentWrong} />
        </Text>
        {error instanceof UserFacingError ? (
          <Text type="body">{error.message}</Text>
        ) : null}
      </view.div>
    </ScreenWrapper>
  );
};

export default AppError;
